import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { ConnectionCount } from "src/types/apps";

import { useGetApp } from "../../AppSettings/Details/hook/useGetApp";
import ProductContext from "../context";
import Context from "./context";

export type TimeSeries = {
	date: string;
	value: number;
};

interface Series {
	type: string;
	name: string;
	data: any[];
}

export default function useDataChart() {
	const { state } = useContext(Context);
	const { product } = useContext(ProductContext);
	const app = useGetApp();

	const { data: connectionsCount } = useQuery<ConnectionCount[]>({
		queryKey: [app?.id, product ? `${product}History` : "allHistory", state.selectedPeriod],
		initialData: []
	});

	const { translate } = useLocales();

	//if (state.isLoading) return { ...state, series: lastCalculatedValueRef.current };

	const result = connectionsCount
		?.reduce(
			(acc, curr) => {
				const existing = acc.find((item) => item.date === curr.date);
				if (existing) {
					existing.count += curr.count;
				} else {
					acc.push({ date: curr.date, count: curr.count });
				}
				return acc;
			},
			[] as { date: string; count: number }[]
		)
		.map((item) => ({ x: item.date, y: item.count }));

	const series: Series[] = [
		{
			type: "area",
			name: translate("overview.connections_number"),
			data: result
		}
	];

	return {
		series
	};
}
